import { BrowserStorage } from './browserStorage';

export const workWithSessionStorage = new BrowserStorage(sessionStorage);
